import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../services/user.service';
import { AddBankAccountComponent } from '../add-bank-account/add-bank-account.component';
import { SessionService } from '../../services/session/session.service';
import {TokenStorageService} from "../../services/storage/token-storage.service";

interface PendingSelection {
  [key: number]: boolean;
}

@Component({
    selector: 'app-add-bank',
    templateUrl: './add-bank.component.html',
    styleUrls: ['./add-bank.component.css'],
    standalone: false
})
export class AddBankComponent implements OnInit {
  errorMessage: string = '';
  loading: boolean = false;
  countries: any[] = [];
  bankList: any;
  instForm: FormGroup = new FormGroup({});
  public pendingSelection: PendingSelection = Object.create(null);
  public selectedBanks: any;
  public unselectedBanks: any = [];
  public assignedBanks: any = [];
  public alreadyassignedBanks: any = [];
  noBankAssigned: boolean = false;
  institutionCode: string = '';
  filterText = '';

  @ViewChild(AddBankAccountComponent) AddBankAccountComponent!: AddBankAccountComponent;
  @Output() apiEvent = new EventEmitter<object>();
  bankAssigned: boolean = false;
  assignBanks: any;
  currencyList: any;
  isUpdate: boolean = false;
  notAddedBankAcc: boolean = true;
  Listloading: boolean = true;
  env:any;
  constructor(
    private toastr: ToastrService,
    private userService: UserService,
    private session: SessionService,
    private tokenStorage: TokenStorageService
  ) { }

  ngOnInit(): void {
    this.env = this.tokenStorage.getUserEnv();
    this.searchUnselected('');
  }
  getValues() {
    this.notAddedBankAcc = this.AddBankAccountComponent.notAddedBankAcc;
  }
  changedValues() {
    this.AddBankAccountComponent.showError = true;
  }

  getBankList(institutionCode: string) {
    this.Listloading = true;
    this.institutionCode = institutionCode;
    this.userService.getUnassignedInstBankList(this.institutionCode).subscribe((data: any) => {
      if (data.status == 'SUCCESS') {
        this.bankList = data.bankList.map((item: any) => ({ ...item, selected: false }))
        this.unselectedBanks = this.bankList.sort((a: any, b: any) =>
          a.bankName > b.bankName ? 1 : -1
        );
        this.Listloading = false;

      } else {
        this.errorMessage = data.reason;
        this.toastr.error(
          this.errorMessage,
          'Error getting bank account list'
        );
      }
    });
    this.userService.getInstBankList(this.institutionCode, 'asia').subscribe((data: any) => {
      if (data.status == 'SUCCESS') {
        this.alreadyassignedBanks = data.bankList.sort((a: any, b: any) =>
          a.bankName > b.bankName ? 1 : -1
        );
      } else {
        this.errorMessage = data.reason;
        this.toastr.error(
          this.errorMessage,
          'Error getting assigned bank account list'
        );
      }
    });
  }

  AssignBankList() {
    this.userService.getInstBankList(this.institutionCode, 'asia').subscribe((data: any) => {
      this.assignBanks = data.bankList.sort((a: any, b: any) =>
        a.bankName > b.bankName ? 1 : -1
      );
      const list = { bank: this.bankAssigned, bankList: data.bankList }
      // this.apiEvent.emit(list)
      this.AddBankAccountComponent.initialize(list)
    });

  }


  searchUnselected(event: any) {
    this.filterText = event;
    if (this.filterText == '') {
      this.unselectedBanks = this.bankList;
    } else {
      this.unselectedBanks = this.unselectedBanks.filter((bank: any) => {
        if (this.filterText != '') {
          return bank.bankName.toLowerCase().includes(this.filterText.toLowerCase());
        }
      });
    }
  }

  get formInstControl(): { [key: string]: AbstractControl } {
    return this.instForm.controls;
  }

  onClickAssignBanks() {
    this.loading = true
    if (this.selectedBanks == undefined || this.selectedBanks.length == 0) {
      this.noBankAssigned = true;
      this.toastr.error('Please assign at least one bank', 'Bank Assign Error');
      this.loading = false
      return;
    }
    this.noBankAssigned = false;

    let bankIds = this.selectedBanks.map(function (item: any) {
      return item['bankId'];
    });
    this.userService.assignInstBanks(bankIds, this.institutionCode)
      .subscribe({
        next: (data) => {
          if (data.status == 'SUCCESS') {
            this.alreadyassignedBanks = this.alreadyassignedBanks.concat(this.selectedBanks)
            this.alreadyassignedBanks = this.alreadyassignedBanks.sort((a: any, b: any) =>
              a.bankName > b.bankName ? 1 : -1
            );
            this.selectedBanks = []
            this.toastr.success(data.reason, 'Success');
            this.bankAssigned = true;
            this.AssignBankList();
          } else {
            this.errorMessage = data.reason;
            this.toastr.error(
              this.errorMessage,
              'Unable to assign banks'
            );
          }
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          this.errorMessage = err.error.message;
          this.toastr.error(
            this.errorMessage,
            'Unable to assign banks'
          );
        },
      });
  }

  reloadPage(): void {
    window.location.reload();
  }

  public addToSelectedBanks(item?: any): void {
    var changeBanks = (item) ? [item] : this.getPendingSelectionFromCollection(this.unselectedBanks);
    this.pendingSelection = Object.create(null);
    this.unselectedBanks = this.removeContactsFromCollection(this.unselectedBanks, changeBanks);
    this.selectedBanks = this.selectedBanks == undefined ? changeBanks : changeBanks.concat(this.selectedBanks);
    this.selectedBanks = this.selectedBanks.map((item: any) => ({ ...item, selected: false }))
  }

  public removeFromSelectedBanks(item?: any): void {
    var changeBanks = (item) ? [item] : this.getPendingSelectionFromCollection(this.selectedBanks);
    this.pendingSelection = Object.create(null);
    this.selectedBanks = this.removeContactsFromCollection(this.selectedBanks, changeBanks);
    this.unselectedBanks = changeBanks.concat(this.unselectedBanks).sort(this.sortContactOperator);
    this.unselectedBanks = this.unselectedBanks.map((item: any) => ({ ...item, selected: false }))
  }

  public togglePendingSelection(item: any): void {
    this.pendingSelection[item.bankId] = !this.pendingSelection[item.bankId];
    item.selected = !item.selected;
  }

  public addAllToSelectedBanks(): void {
    this.selectedBanks = []
    this.selectedBanks.push(...this.bankList);
    this.unselectedBanks = []
    this.selectedBanks = this.selectedBanks.map((item: any) => ({ ...item, selected: false }))
  }

  public addAllToUnselectedBanks(): void {
    this.selectedBanks == undefined ? this.selectedBanks = [] : true
    this.unselectedBanks.push(...this.selectedBanks);
    this.selectedBanks = []
    this.unselectedBanks.sort(this.sortContactOperator)
    this.unselectedBanks = this.unselectedBanks.map((item: any) => ({ ...item, selected: false }))
  }

  private getPendingSelectionFromCollection(collection: any[]): any[] {
    var selectionFromCollection = collection.filter(
      (bank) => {
        var id = bank.bankId
        return (bank.bankId in this.pendingSelection && this.pendingSelection[id] == true);
      }
    );
    return (selectionFromCollection);
  }

  private removeContactsFromCollection(
    collection: any[],
    contactsToRemove: any[]
  ): any[] {

    var collectionWithoutContacts = collection.filter(
      (contact) => {
        return (!contactsToRemove.includes(contact));
      }
    );

    return (collectionWithoutContacts);
  }

  private sortContactOperator(a: any, b: any): number {
    return (a.bankName.localeCompare(b.bankName));
  }

}
